(function(){
  const root = document.documentElement;
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-menu-overlay]');
  const button = document.querySelector('[data-menu-toggle]');
  function openMenu(){ if(!drawer) return; drawer.classList.add('is-open'); overlay.classList.add('is-open'); root.classList.add('sl-no-scroll'); drawer.setAttribute('aria-hidden','false'); if(button) button.setAttribute('aria-expanded','true'); }
  function closeMenu(){ if(!drawer) return; drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); root.classList.remove('sl-no-scroll'); drawer.setAttribute('aria-hidden','true'); if(button) button.setAttribute('aria-expanded','false'); }
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-menu-toggle]')){e.preventDefault(); openMenu();}
    if(e.target.closest('[data-menu-close]') || e.target.closest('[data-menu-overlay]')){e.preventDefault(); closeMenu();}
    const expander=e.target.closest('[data-mobile-expander]');
    if(expander){e.preventDefault();const item=expander.closest('.sl-mobile-nav__item');item.classList.toggle('is-open');expander.setAttribute('aria-expanded',item.classList.contains('is-open')?'true':'false');}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape') closeMenu();});
})();

(function(){
  const hero=document.querySelector('[data-hero-carousel]');
  if(!hero) return;
  const slides=Array.from(hero.querySelectorAll('.sl-hero__slide'));
  if(slides.length<2) return;
  let current=0;
  window.setInterval(function(){
    slides[current].classList.remove('is-active');
    current=(current+1)%slides.length;
    slides[current].classList.add('is-active');
  },3000);
})();

